export enum Translations {
    ConfirmModelChangeTitle = 'apply_model_dialog.confirm_model_change_title',
    ConfirmModelChangeText = 'apply_model_dialog.confirm_model_change_text',
    UpdateBtn = 'btn.update'
}